import { Address } from 'viem';

import { EvmNFTCollection } from '@repo/types-client';

import { evmNFTCollections } from '../data';

/**
 * Retrieves an EVM NFT collection by its contract address
 *
 * @param address - The Ethereum address of the NFT collection contract
 * @returns The corresponding EvmNFTCollection object
 * @throws {Error} If no collection is found for the given address
 *
 * @example
 * const collection = getEvmNFTCollectionByAddress('0x1234...')
 */
export const getEvmNFTCollectionByAddress = (
  address: Address,
): EvmNFTCollection => {
  // Search through the collections to find one matching the provided address
  // Addresses are compared case-insensitively
  const key = Object.keys(evmNFTCollections).find(
    (key) =>
      evmNFTCollections[key]?.getAddress()?.toLowerCase() ===
      address.toLowerCase(),
  );

  // If no matching collection is found, throw an error
  if (!key) {
    throw new Error('Invalid contract name');
  }

  return evmNFTCollections[key] as EvmNFTCollection;
};
